// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1728px) {
    .scl--wpchs-cont-stl-bo{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--wpcjus-section-job-seek{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--web-page-career-our-talent-content{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--web-page-career-join-us-title-side{
        width: 40%;
    }

    .scl--web-page-career-join-us-job-list-side{
        width: 60%;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{
        font-size: 20px;
    }
}

@media (max-width: 1440px) {
    .scl--web-page-career-join-us-job-list-side{
        padding-left: 0px;
        width: 100%;
    }

    .scl--wpchs-cont-stl-bo .scl--web-component-hero-title span{
        font-size: 70px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item{
        gap: 0px;
        justify-content: space-between;
    }

    .scl--web-page-career-join-us-job-list-side .scl--web-component-job-role-title{
        font-size: 28px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container h2{
        font-size: 50px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{
        font-size: 18px;
    }

    .scl--web-page-career-join-us-title-side{
        width: 100%;
    }

    .scl--wpcjus-section-job-seek{
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/career/css/careerSl.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["@media (max-width: 1728px) {\n    .scl--wpchs-cont-stl-bo{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--wpcjus-section-job-seek{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--web-page-career-our-talent-content{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--web-page-career-join-us-title-side{\n        width: 40%;\n    }\n\n    .scl--web-page-career-join-us-job-list-side{\n        width: 60%;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{\n        font-size: 20px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .scl--web-page-career-join-us-job-list-side{\n        padding-left: 0px;\n        width: 100%;\n    }\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-hero-title span{\n        font-size: 70px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item{\n        gap: 0px;\n        justify-content: space-between;\n    }\n\n    .scl--web-page-career-join-us-job-list-side .scl--web-component-job-role-title{\n        font-size: 28px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container h2{\n        font-size: 50px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{\n        font-size: 18px;\n    }\n\n    .scl--web-page-career-join-us-title-side{\n        width: 100%;\n    }\n\n    .scl--wpcjus-section-job-seek{\n        flex-direction: column;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
